import { ReactComponent as SolutionDesignIcon } from './solution-design.svg';
import "./redirect.scss";

const Redirect = () => {
    return (
        <div className="xsd-redirect msds-block-padding-large msds-bg-gray-1">
            <SolutionDesignIcon className="xsd-page-not-found__icon" />
            <h2>
                <div className="msds-text-header-1-bold msds-text-dark-blue">
                    Loading
                    <span className="xsd-redirect__loading-dots">
                        <span className="xsd-redirect__loading-dot">.</span>
                        <span className="xsd-redirect__loading-dot">.</span>
                        <span className="xsd-redirect__loading-dot">.</span>
                    </span>
                </div>
            </h2>
        </div>
    );
};

export default Redirect